<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div
    class="knowledge-test__state"
    :class="{ 'knowledge-test__state--passed': passed }"
  >
    <span v-if="icon" class="knowledge-test__state-icon" aria-hidden="true">{{
      icon
    }}</span>
    <div v-if="typeof score === 'number'" class="knowledge-test__score">
      <b>{{ score }}</b
      ><span>/ 10</span>
    </div>
    <h3>{{ $t(title) }}</h3>
    <p v-if="text">{{ $t(text) }}</p>
    <button
      v-if="buttonLabel"
      type="button"
      class="knowledge-test__button"
      :disabled="buttonDisabled"
      @click="$emit('action')"
    >
      {{ $t(buttonLabel) }}
    </button>
  </div>
</template>
